export default {
    title: "評分系統",
    footer: ["面試管理專家", "大型面試的好幫手", "版本{version}"],
    footerBoc: ["中國銀行面試評分系統"],
    placeholder: {
        email: "郵箱",
        password: "密碼",
    },
    login: "登錄",
    detectionTips: "如有視頻日程，請先進行",
    detectionButton: "設備檢測",
    failMsg: "用戶名或密碼錯誤，請重試",
};
